import useUserAppClipExperiences from 'hooks/use-user-app-clip-experiences'
import moment from 'moment'
import { Card, Table, Collapse } from 'react-bootstrap'

const UserAppClipExperiencesTable = ({
  userUuid,
  isExpanded,
  setIsExpanded,
}: {
  userUuid: string
  isExpanded: boolean
  setIsExpanded: (value: boolean) => void
}) => {
  const { data: appClipExperiences, isLoading } =
    useUserAppClipExperiences(userUuid)

  return (
    <Card className="mb-2">
      <Card.Header
        className="d-flex justify-content-between align-items-center"
        style={{ cursor: 'pointer' }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h4 className="mb-0">App Clip Experiences</h4>
        <ion-icon
          name="chevron-down-outline"
          style={{
            fontSize: '20px',
            color: '#4da6ff',
            transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease-in-out',
          }}
        />
      </Card.Header>

      <Collapse in={isExpanded} timeout={300}>
        <div>
          <Card.Body>
            {isLoading ? (
              <p>Loading...</p>
            ) : !appClipExperiences?.length ? (
              <Card.Text>No App Clip Experiences With This User</Card.Text>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <Table striped hover bordered size="sm" variant="dark">
                  <tbody>
                    {appClipExperiences?.map(
                      ({
                        id,
                        card_id,
                        cloudinary_image_url,
                        remote_id,
                        is_active,
                        subtitle,
                        title,
                        url,
                        created_at,
                        updated_at,
                      }) => (
                        <tr className="" key={id}>
                          <td style={{ verticalAlign: 'middle' }}>
                            <img
                              src={cloudinary_image_url}
                              alt={title}
                              className="bg-white img-fluid img-thumbnail my-1"
                              style={{ maxWidth: '100px' }}
                            />
                          </td>
                          <td
                            style={{
                              wordBreak: 'break-word',
                              maxWidth: '500px',
                            }}
                          >
                            <p className="my-1">
                              <span className="text-white-50">Title:</span>{' '}
                              {title}
                            </p>
                            <p className="mb-1">
                              <span className="text-white-50">Subtitle:</span>{' '}
                              {subtitle}
                            </p>
                            <p className="mb-1">
                              <span className="text-white-50">
                                Attached Card ID:
                              </span>{' '}
                              {card_id}
                            </p>
                            <p
                              className="mb-1"
                              style={{ wordBreak: 'break-all' }}
                            >
                              <span className="text-white-50">
                                App Clip URL:
                              </span>{' '}
                              {url}
                            </p>
                            <p className="mb-1">
                              <span className="text-white-50">Status:</span>{' '}
                              {is_active ? 'Active' : 'Inactive'}
                            </p>
                            <p className="mb-1">
                              <span className="text-white-50">Remote ID:</span>{' '}
                              {remote_id}
                            </p>
                            <p className="my-1">
                              <span className="text-white-50">Created:</span>{' '}
                              {created_at
                                ? moment(created_at).format('lll')
                                : 'N/A'}
                            </p>
                            <p className="my-1">
                              <span className="text-white-50">Updated:</span>{' '}
                              {updated_at
                                ? moment(updated_at).format('lll')
                                : 'N/A'}
                            </p>
                          </td>
                          <td style={{ verticalAlign: 'middle' }}>
                            <a
                              href={`https://appstoreconnect.apple.com/appclips/ui/app-experience-review/${remote_id}`}
                              target="_blank"
                              className="btn btn-primary"
                              rel="noreferrer"
                            >
                              Appstore Connect ↗️
                            </a>
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </Table>
              </div>
            )}
          </Card.Body>
        </div>
      </Collapse>
    </Card>
  )
}

export default UserAppClipExperiencesTable
